import { activateItems, getTheCtrByEvent, stopLoop, theaterPausePlay } from './activate';
import { classNames, selectors } from './lib';
import * as Utils from './utils';

export const addMouseEventListeners = (item) => {
	item.addEventListener('mouseenter', theaterPausePlay);
	item.addEventListener('mouseleave', theaterPausePlay);
};

export const addClickEventListeners = (item) => {
	item.addEventListener('click', (event) => {
		let { elm, ctr, ctrId } = getTheCtrByEvent(event);

		// Remove autoplay functions
		ctr.setAttribute('data-autoplay', '0');
		ctr.querySelectorAll(`${selectors.nav}, ${selectors.content}`).forEach((el) => {
			el.removeEventListener('mouseenter', theaterPausePlay);
			el.removeEventListener('mouseleave', theaterPausePlay);
		});

		if (!event.target.classList.contains(classNames.navEntry)) {
			elm = event.target.closest(selectors.nav);
		}

		stopLoop(ctrId);
		activateItems(ctrId, Utils.getIndex(elm));
	});
};
